import React, {useEffect} from 'react';
import {Dialog} from 'primereact/dialog';
import RequireAuthenticationController from './controller/require-authentication.controller';
import {Button} from 'primereact/button';
import AuthModel from '../../model/AuthModel';
import Container from '../Container';
import Field from '../Field';
import {Password} from 'primereact/password';
import './index.scss';
import AuthService from '../../services/authService';

interface Props {
  accept: any;
  reject: any;
  auth: AuthModel;
  text?: any;
}

export default function RequireAuthenticationDialog(props: Props) {
  const text = !props.text ? 'Informe sua senha para prosseguir com esta ação.' : props.text;
  const auth = props.auth;
  const controller = new RequireAuthenticationController();

  useEffect(() => {
    props.auth.setPassword('');
  }, [props.auth.visible])

  function renderFooter() {
    return (
      <div>
        <Button
          label="&times; Cancelar"
          type="button"
          icon="pi pi-times"
          onClick={() => props.reject()}
          className="p-button-text"
        />
        <Button
          type="button"
          label="Confirmar"
          icon="pi pi-check"
          onClick={() => controller.autenticar(auth.password, () => props.accept())}
        />
      </div>
    );
  }

  return (
    <Dialog
      header="Confirmação"
      visible={props.auth.visible}
      modal
      className="require-authentication-dialog"
      baseZIndex={6000}
      closable={false}
      draggable={false}
      footer={renderFooter()}
      onHide={() => props.reject()}
    >
      <div style={{marginBottom: '20px'}}>
        <label><b>Usuário: </b>{AuthService.getUser() && AuthService.getUser().nome}</label>
      </div>
      <div className="d-flex justify-content-between align-content-center ">
        <span>{text}</span>
      </div>
      <Container>
        <Field col={12}>
          <Password
            className="require-authentication-password-field"
            style={{width: '100%'}}
            maxLength={51}
            feedback={false}
            toggleMask
            value={auth.password}
            onKeyDown={(e) => e.keyCode == 13}
            onChange={(e) => auth.setPassword(e.target.value)}
          />
        </Field>
      </Container>
    </Dialog>
  );
}
